import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitQuiz = (payload) => api.post("/quiz/submit", payload).then(r => r.data);
export const getSubmission = (id) => api.get(`/quiz/${id}`).then(r => r.data);
export const createCheckout = (payload) => api.post("/checkout/session", payload).then(r => r.data);
export const getCheckoutStatus = (sessionId) => api.get(`/checkout/status/${sessionId}`).then(r => r.data);
export const getCloudinarySig = (folder = "cooking-assistant/uploads") =>
    api.get("/cloudinary/signature", { params: { folder } }).then(r => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then(r => r.data);
export const adminOrders = (token) =>
    api.get("/admin/orders", { headers: { "X-Admin-Password": token } }).then(r => r.data);
export const adminDeliver = (token, payload) =>
    api.post("/admin/deliver", payload, { headers: { "X-Admin-Password": token } }).then(r => r.data);
export const adminDeleteOrder = (token, submissionId) =>
    api.delete(`/admin/orders/${submissionId}`, { headers: { "X-Admin-Password": token } }).then(r => r.data);
export const adminSyncOrder = (token, submissionId) =>
    api.post(`/admin/orders/${submissionId}/sync`, {}, { headers: { "X-Admin-Password": token } }).then(r => r.data);
export const adminSendRecovery = (token, submissionId) =>
    api.post(`/admin/orders/${submissionId}/recover`, {}, { headers: { "X-Admin-Password": token } }).then(r => r.data);
export const adminRunRecoverySweep = (token) =>
    api.post(`/admin/recovery/run`, {}, { headers: { "X-Admin-Password": token } }).then(r => r.data);
export const adminMarkDelivered = (token, submissionId) =>
    api.post(`/admin/orders/${submissionId}/mark-delivered`, {}, { headers: { "X-Admin-Password": token } }).then(r => r.data);
export const adminMoveToPending = (token, submissionId) =>
    api.post(`/admin/orders/${submissionId}/move-to-pending`, {}, { headers: { "X-Admin-Password": token } }).then(r => r.data);
